import React from "react";
import { Chart } from "react-google-charts";
import Spinner from "../../../spinner/spinner";

export const options = {
    colors: ['#0000cc', '#990000'],
    title: "Pickup Request and Completed Performance",
    fontSize: 15,
    chartArea: { width: "50%" },
    isStacked: true,
    hAxis: {
        title: "Route",
        fontSize: 15,
        titleTextStyle: {
            color: '#333',
            bold: true
        },
        align: "end",
        minValue: 0,
    },
    vAxis: {
        title: "Count",
        fontSize: 15,
        titleTextStyle: {
            color: '#333',
            bold: true
        },
        baselineColor: "#000000"
    },
    series: {
        0: {
            curveType: 'function'
        },
        1: {
            curveType: 'function'
        }
    }
};

export default function PickupPerformanceChart({ data, loading }) {

    return (
        <div justifyContent="center">
            {loading ? (
                <Spinner />
            ) : (
                data.length > 1 ? (
                    <Chart
                        chartType="ColumnChart"
                        style={{ marginTop: "20px", marginBottom: "20px", width: "100%", height: "400px" }}
                        width="100%"
                        height="400px"
                        data={data}
                        options={options}
                    />
                ) : (
                    <h3>No Data Available</h3>
                )
            )}
        </div>
    );
}
